import { render } from "./LandingPage.vue?vue&type=template&id=3b14f3ca&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"

import "./LandingPage.vue?vue&type=style&index=0&id=3b14f3ca&scoped=true&lang=css"

import exportComponent from "/Users/emil/dev/topp-landing-page/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b14f3ca"]])

export default __exports__